import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import { popUp, commonData } from "@/mixins/index";
export default {
  mixins: [popUp, commonData],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        account: "",
        appid: "",
        user_id: ''
      },
      isSumbit: true,
      rules: {
        account: [{
          required: true,
          message: "请输入账号",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.copyPrimitive();

                if (data) {
                  console.log("data==", data);
                  _this.formData.id = data.id;
                  _this.formData.appid = data.appid;
                  _this.formData.account = data.account, _this.formData.user_id = data.user_id;
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handlePhoneBlur: function handlePhoneBlur() {
      var _this2 = this;

      if (!this.formData.account) {
        return;
      } // 调用接口


      this.$api.checkAccountByUser({
        appid: this.formData.appid,
        account: this.formData.account,
        isMustAppid: 1
      }).then(function (res) {
        if (res.status == 200) {
          _this2.isSumbit = false;
        } else {
          _this2.isSumbit = true;
        }
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 5;
                    break;
                  }

                  data = JSON.parse(JSON.stringify(_this3.formData));

                  _this3.$api.checkAccountByUser(_objectSpread(_objectSpread({}, data), {}, {
                    isMustAppid: 1
                  })).then(function (res) {
                    if (res.status == 200) {
                      _this3.$message({
                        message: '操作成功',
                        type: 'success'
                      });

                      _this3.dialogFormVisible = false;

                      _this3.$emit('change');
                    }
                  });

                  _context2.next = 6;
                  break;

                case 5:
                  return _context2.abrupt("return", false);

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};